// Save / open a text file. In Electron this opens the native OS dialogs (so the
// user picks the location and name); in a plain browser it falls back to an
// anchor download and a hidden file input. Returns a normalized result either
// way: { canceled } or { canceled:false, filePath?, name?, contents? }.

const electronFiles = () =>
  typeof window !== "undefined" && window.electronAPI?.isElectron
    ? window.electronAPI.files
    : null;

export const saveTextFile = async ({ defaultName, contents }) => {
  const files = electronFiles();
  if (files?.save) {
    return files.save({ defaultName, contents });
  }
  // Browser fallback: trigger a download (no location prompt).
  const blob = new Blob([contents ?? ""], {
    type: "application/json;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = defaultName || "export.json";
  a.click();
  URL.revokeObjectURL(url);
  return { canceled: false, filePath: defaultName };
};

export const openTextFile = async ({ filters, accept = ".json" } = {}) => {
  const files = electronFiles();
  if (files?.open) {
    return files.open({ filters });
  }
  // Browser fallback: a hidden file input read as text.
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        resolve({ canceled: true });
        return;
      }
      const reader = new FileReader();
      reader.onload = () =>
        resolve({
          canceled: false,
          name: file.name,
          contents: String(reader.result || ""),
        });
      reader.onerror = () => resolve({ canceled: true });
      reader.readAsText(file);
    };
    input.click();
  });
};
